import { render } from "./ExamReportList.vue?vue&type=template&id=01a116ef"
import script from "./ExamReportList.vue?vue&type=script&lang=js"
export * from "./ExamReportList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__